import React from 'react';
import styles from './StoryCard.module.scss';

export const StoryCard = ({ title, highlightedText, afterHighlightedText, description, style, children, backgroundColor }) => {
  return (
    <div className={styles.card} style={style}>
      <div className={styles.cardContent} style={{ backgroundColor }}>
        <div className={styles.cardBody}>
          <div className={styles.title}>
            {title}
            {highlightedText && (
              <>
                <br />
                <span className={styles.highlight}>{highlightedText}</span>
              </>
            )}
            {" "}{afterHighlightedText} 
          </div>
          <div className={styles.description}>
            {description}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};